var _defs, _rect, _rect2, _path, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#ffffff",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#ffffff",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3e3b34",
    d: "M 265.746094 54.113281 C 255.386719 43.753906 238.585938 43.753906 228.226562 54.113281 L 103.019531 179.320312 C 99.316406 183.023438 96.792969 187.742188 95.765625 192.878906 L 90.570312 218.835938 C 88.097656 231.214844 99.007812 242.125 111.386719 239.652344 L 137.34375 234.457031 C 142.480469 233.429688 147.199219 230.90625 150.902344 227.203125 L 276.105469 101.996094 C 286.46875 91.636719 286.46875 74.835938 276.105469 64.476562 Z M 240.730469 66.621094 C 244.1875 63.167969 249.785156 63.167969 253.238281 66.621094 L 263.601562 76.984375 C 267.054688 80.4375 267.054688 86.035156 263.601562 89.488281 L 239.972656 113.117188 L 217.105469 90.25 Z M 204.597656 102.753906 L 115.527344 191.828125 C 114.292969 193.0625 113.449219 194.636719 113.109375 196.347656 L 107.917969 222.304688 L 133.875 217.113281 C 135.585938 216.773438 137.160156 215.929688 138.394531 214.695312 L 227.464844 125.625 Z M 204.597656 102.753906 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3e3b34",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(139.955854, 322.642283)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.5625 -16.34375 L 2.28125 -22 L 4.25 -21.390625 L 4.25 -35.40625 L 23.171875 -35.40625 L 23.171875 -29.390625 L 10.828125 -29.390625 L 10.828125 -19.78125 L 25.484375 -15.828125 L 23.765625 -10.0625 L 10.828125 -13.609375 L 10.828125 -6.46875 L 25.390625 -6.46875 L 25.390625 0 L 4.25 0 L 4.25 -15.171875 Z M 0.5625 -16.34375 "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#3e3b34",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(167.063723, 322.642283)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 2.984375 0 L 2.984375 -35.40625 L 11.375 -35.40625 C 13.84375 -35.40625 15.894531 -35.082031 17.53125 -34.4375 C 19.164062 -33.800781 20.460938 -32.96875 21.421875 -31.9375 C 22.378906 -30.90625 23.09375 -29.789062 23.5625 -28.59375 C 24.039062 -27.40625 24.351562 -26.242188 24.5 -25.109375 C 24.65625 -23.984375 24.734375 -23.015625 24.734375 -22.203125 L 24.734375 -11.53125 C 24.734375 -10.144531 24.488281 -8.769531 24 -7.40625 C 23.507812 -6.039062 22.800781 -4.800781 21.875 -3.6875 C 20.945312 -2.570312 19.832031 -1.675781 18.53125 -1 C 17.238281 -0.332031 15.78125 0 14.15625 0 Z M 9.5625 -6.265625 L 13.046875 -6.265625 C 14.898438 -6.265625 16.210938 -6.820312 16.984375 -7.9375 C 17.765625 -9.050781 18.15625 -10.804688 18.15625 -13.203125 L 18.15625 -22.109375 C 18.15625 -23.785156 17.882812 -25.144531 17.34375 -26.1875 C 16.800781 -27.238281 16.117188 -28 15.296875 -28.46875 C 14.472656 -28.945312 13.585938 -29.1875 12.640625 -29.1875 L 9.5625 -29.1875 Z M 9.5625 -6.265625 "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#3e3b34",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.019864, 322.642283)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.03125 0 L 3.03125 -35.40625 L 9.609375 -35.40625 L 9.609375 0 Z M 3.03125 0 "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#3e3b34",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(206.714025, 322.642283)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 10.71875 -28.828125 L 1.921875 -28.828125 L 1.921875 -35.296875 L 26.40625 -35.296875 L 26.40625 -28.828125 L 17.296875 -28.828125 L 17.296875 0 L 10.71875 0 Z M 10.71875 -28.828125 "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCard);
export default __webpack_public_path__ + "static/media/edit-card.76bc62f2c4a5f7b8f9d69100cadf6fa4.svg";
export { ForwardRef as ReactComponent };